<app-timezone-select [timezoneInput]="timezoneInput" (timezoneOutput)="onOutput($event)"></app-timezone-select>
<div style="color: red; font-size: 10px" *ngIf="hasError(timezoneInput)">Timezone is not valid.</div>
